import { ArrowSmRightIcon, RefreshIcon } from '@heroicons/react/solid'
import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Code,
  Form,
  ErrorMissingData,
  Paragraph,
  StickyFooter,
  Title,
  LocationInfo,
} from 'src/components'
import EmailHelpBox from 'src/components/Layout/EmailHelpBox'
import { getSetupPolicy } from './policy'
import { savedAccountId, savedPolicyName, savedUserGroup } from './storage'
import InputField from 'src/components/Shared/UIComponents/InputField'
import CustomButton from 'src/components/Shared/UIComponents/Button'
import { toast } from 'sonner'

type Props = {
  accountId: string
  userGroup: string
}

const defaultPolicyName = 'mc_setup_policy'

function CreatePolicy(props: Props) {
  const navigate = useNavigate()
  const [policyName, setPolicyName] =
    savedPolicyName.useState(defaultPolicyName)

  const policy = useMemo(
    () =>
      JSON.stringify(getSetupPolicy(props.accountId, props.userGroup), null, 4),
    [props.accountId, props.userGroup],
  )

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault()
        navigate('../user')
      }}
    >
      <Title label="Create Policy" />

      <LocationInfo path="AWS Console/IAM/Policies/Create policy" />

      <Paragraph className="col-span-full">
        You should create a policy, the default name is{' '}
        <b>{defaultPolicyName}</b> but you can change it below.
        <br />
        Open the JSON tab and copy-paste the code below.
      </Paragraph>
      <InputField
        label="policy name"
        placeholder="type your policy name"
        value={policyName}
        setValue={setPolicyName}
      />
      <CustomButton
        type="button"
        onClick={() => {
          navigator.clipboard.writeText(policy)
          toast.success('The policy has been copied to your clipboard.')
        }}
        label="Copy JSON"
        className="self-end justify-self-end"
      />
      <Code content={policy} className="col-span-full" />
      <StickyFooter>
        <EmailHelpBox className="flex-1" />
        <CustomButton
          type="submit"
          label="next"
          icon={<ArrowSmRightIcon />}
          iconPosition="right"
          className="ml-auto "
        />
      </StickyFooter>
    </Form>
  )
}

export default function ValidateCreatePolicy() {
  const navigate = useNavigate()
  const [accountId] = savedAccountId.useState('')
  const [userGroup] = savedUserGroup.useState('')

  if (!accountId || !userGroup) {
    return (
      <ErrorMissingData
        missingValues={{
          accountId: !accountId,
          userGroup: !userGroup,
        }}
      >
        <CustomButton
          label="restart setup"
          onClick={() => navigate('../arn')}
          icon={<RefreshIcon />}
          iconPosition="left"
        />
      </ErrorMissingData>
    )
  }

  return <CreatePolicy accountId={accountId} userGroup={userGroup} />
}
